import { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './JournalOverview';
import './workspace-flow.css';

const mountedPanels = new Set();
let unlockedOverflow = '';

export default function WorkspaceDialog({ title, label=title, children, onClose, className = '', busy = false, dismissible = true, header=true, style }) {
  const titleId = useId(), panel = useRef(null), close = useRef(onClose);
  const isBusy = useRef(busy); isBusy.current = busy;
  close.current = onClose;
  const canDismiss=useRef(dismissible);canDismiss.current=dismissible;
  useEffect(() => {
    const previous = document.activeElement, currentPanel = panel.current;
    if (!mountedPanels.size) unlockedOverflow = document.body.style.overflow;
    mountedPanels.add(currentPanel);
    document.body.style.overflow = 'hidden';
    const isTop = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].at(-1) === currentPanel;
    (panel.current?.querySelector('[data-autofocus]') || panel.current)?.focus();
    const key = event => {
      if (!isTop() || event.defaultPrevented) return;
      if (event.key === 'Escape') {
        if (event.target.closest?.('[data-tl-popover],[role="combobox"][aria-expanded="true"]')) return;
        event.preventDefault(); if(!isBusy.current&&canDismiss.current)close.current();
      }
      if (event.key !== 'Tab') return;
      const items = [...panel.current.querySelectorAll('button:not(:disabled),input:not(:disabled):not([type="hidden"]),textarea:not(:disabled),select:not(:disabled),a[href],[tabindex="0"]')].filter(item=>item.tabIndex>=0&&!item.closest('[hidden],[aria-hidden="true"]')&&getComputedStyle(item).display!=='none'&&getComputedStyle(item).visibility!=='hidden');
      if (!items.length) { event.preventDefault(); return; }
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', key);
    return () => {
      mountedPanels.delete(currentPanel);
      if (!mountedPanels.size) document.body.style.overflow = unlockedOverflow;
      document.removeEventListener('keydown', key);
      const top = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].filter(item=>item!==currentPanel).at(-1);
      if (previous?.isConnected && (!top || top.contains(previous))) previous.focus({preventScroll:true});
    };
  }, []);
  return createPortal(<div className="tl-workspace-scrim" onMouseDown={event => { if (event.target === event.currentTarget && !busy && dismissible) onClose(); }}>
    <section className={`tl-workspace-dialog ${className}`} style={style} ref={panel} role="dialog" aria-modal="true" aria-label={!header?label:undefined} aria-labelledby={header?titleId:undefined} aria-busy={busy} tabIndex={-1} data-tl-navigation-dialog>
      {header&&<header><h2 id={titleId}>{title}</h2>{dismissible&&<button className="tl-icon-button" aria-label={`Close ${title.toLowerCase()}`} onClick={onClose} disabled={busy}><Icon name="close"/></button>}</header>}
      {children}
    </section>
  </div>, document.body);
}
